import { gql } from 'apollo-angular';

export const DASHBOARD_OVERVIEW = gql`
  query dashboardOverview {
    dashboardOverview {
      totalUser
      totalDistance
      totalPartner
      totalPartnerEarnings
      totalComissions
      rideHailingTwoWheelsCount
      rideHailingFourWheelsCount
      expressTwoWheelsCount
      expressFourWheelsCount
      totalApprovedTwowheels
      totalApprovedFourWheels
    }
  }
`;

export const DASHBOARD_EXPRESS_OVERVIEW = gql`
  query dashboardExpressOverview {
    dashboardExpressOverview {
      twoWheelsPartnerCount
      fourWheelsPartnerCount
      twoWheelsBookingCount
      fourWheelsBookingCount
      totalTwoWheelsEarnings
      totalFourWheelsEarnings
      totalTwoWheelsComissions
      totalFourWheelsComissions
    }
  }
`;

export const DASHBOARD_RIDE_OVERVIEW = gql`
  query dashboardRideOverview($service: BookingRideServiceFilterInput!) {
    dashboardRideOverview(service: $service) {
      twoSeatersPartnerCount
      fourSeatersPartnerCount
      sixSeatersPartnerCount

      twoSeatersBookingCount
      fourSeatersBookingCount
      sixSeatersBookingCount

      totalTwoSeatersEarnings
      totalFourSeatersEarnings
      totalSixSeatersEarnings
      
      totalTwoSeaterssComissions
      totalFourSeaterssComissions
      totalSixSeaterssComissions
    }
  }
`; 